import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker-v2';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';
import _ from 'lodash';

import CustomDayPickerInput from './custom_day_picker_input';

import './brzw_day_picker.scss';

const CLASS_NAME = 'brzw-day-picker';

const BrzwDayPicker = ({
  calendarClassName,
  children,
  className,
  customInput,
  dateFormat,
  datePickerProps,
  disabled,
  error,
  futureOnly,
  icon,
  id,
  inputClassName,
  label,
  minDate,
  onChange,
  placeholderText,
  selected,
  theme,
  withClearAction,
}) => {
  const [highlightedDate, setHighlightedDate] = useState(selected);
  const customInputRef = useRef(null);
  const datePickerRef = useRef(null);
  const wrapperRef = useRef(null);
  const minDefaultDate = futureOnly ? new Date() : null;
  const minPickerDate = minDate || minDefaultDate;
  const onChangeDateByInput = date => {
    onChange(date);
    _.invoke(datePickerRef, 'current.setOpen', false);
  };
  const highlightedDatesObject = _.isDate(highlightedDate) && [
    {
      'brzw-day-picker__day--highlighted': [highlightedDate],
    },
  ];

  useEffect(() => {
    setHighlightedDate(selected);
  }, [selected]);

  return (
    <div className={classnames(CLASS_NAME, className)} ref={wrapperRef}>
      <ReactDatePicker
        calendarClassName={calendarClassName}
        className={inputClassName}
        customInput={
          customInput || (
            <CustomDayPickerInput
              error={error}
              icon={icon}
              id={id}
              inputRef={customInputRef}
              isMobile={isMobile}
              label={label}
              minDate={minPickerDate}
              onChangeDate={onChangeDateByInput}
              placeholder={placeholderText}
              selectedDate={selected}
              setHighlightedDate={setHighlightedDate}
              theme={theme}
              withClearAction={withClearAction}
              wrapperRef={wrapperRef}
            />
          )
        }
        customInputRef={customInputRef}
        dateFormat={dateFormat}
        fixedHeight
        highlightDates={highlightedDatesObject}
        minDate={minPickerDate}
        nextMonthButtonLabel=""
        onChange={onChange}
        openToDate={highlightedDate || selected}
        placeholderText={placeholderText}
        previousMonthButtonLabel=""
        readOnly={disabled}
        ref={datePickerRef}
        selected={selected}
        {...datePickerProps}
      >
        {children}
      </ReactDatePicker>
    </div>
  );
};

BrzwDayPicker.propTypes = {
  calendarClassName: PropTypes.string,
  children: PropTypes.shape({}),
  className: PropTypes.string,
  customInput: PropTypes.shape({}),
  dateFormat: PropTypes.string,
  datePickerProps: PropTypes.shape({}),
  disabled: PropTypes.bool,
  error: PropTypes.string,
  futureOnly: PropTypes.bool,
  icon: PropTypes.string,
  id: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  minDate: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  selected: PropTypes.shape({}),
  theme: PropTypes.string,
  withClearAction: PropTypes.bool,
};

BrzwDayPicker.defaultProps = {
  calendarClassName: '',
  children: null,
  className: '',
  customInput: null,
  dateFormat: 'MMM d, yyyy',
  datePickerProps: {},
  futureOnly: false,
  icon: 'schedule',
  inputClassName: '',
  label: '',
  placeholderText: 'Add date',
  withClearAction: true,
};

export default BrzwDayPicker;
